export const currentEnvironment = () => {
  const env = process.env.REACT_APP_ENV || '';

  if (env.includes('dev') || env.includes('uat')) {
    return 'staging';
  }

  return 'production';
};

export const isStaging = () => currentEnvironment() === 'staging';
export const isProduction = () => currentEnvironment() === 'production';
